import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { mapGetters, mapState } from "vuex";
import { PRIVACY_EXTERNAL_LINK, TOS_EXTERNAL_LINK } from "@Shared/@Utils/constants";
import NewAppModal from "../../subdomain-interstitial/new-application-modal.vue";
import { EMAIL_VERIFIED, GET_ACCOUNT_AGENTS } from "@Client/@Modules/main/store/account/account-getters";
import { kebabCase } from "lodash";
import { defineComponent } from "@vue/composition-api";
import { logout } from "@Client/@Modules/main/api/account-api";
import { OUTSTANDING_CLASSIFICATIONS } from "../../documents/store/document-getters";
export default defineComponent({
  name: "PageSidebar",
  components: {
    ProfileAvatar,
    NewAppModal
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", ["userDetails", "accountDetails", "permissions", "selectedApplicationId"])), mapState("DeprecatedApplicationStore", {
    applications(state) {
      return state.applications;
    }
  })), mapState("DocumentStore", ["classifications", "documents"])), mapGetters("AccountStore", [EMAIL_VERIFIED, GET_ACCOUNT_AGENTS])), mapGetters("DocumentStore", [OUTSTANDING_CLASSIFICATIONS])), {}, {
    hasMoreThanOneApplications() {
      return this.applications.allIds.length > 1 || this.agentsListLength > 1;
    },
    fullName() {
      const {
        givenName,
        familyName
      } = this.userDetails;
      return `${givenName} ${familyName}`;
    },
    fontSizeFullName() {
      return this.fullName.length > 30 ? "0.9rem" : "inherit";
    },
    filteredMenu() {
      const {
        sections
      } = this.menu;
      return _mapInstanceProperty(sections).call(sections, section => {
        var _context;
        return _objectSpread(_objectSpread({}, section), {}, {
          tabs: _filterInstanceProperty(_context = section.tabs).call(_context, tab => tab.can !== "none")
        });
      });
    },
    menu() {
      return {
        sections: [{
          name: "",
          tabs: [{
            name: this.$t("sidebar.sections.dashboard"),
            route: "dashboard",
            can: "all"
          }, {
            name: this.$t("sidebar.sections.mortgageApplication"),
            route: "application",
            can: "all"
          }, {
            name: this.$t("sidebar.sections.switchApplication"),
            route: "subdomain-interstitial",
            can: this.hasMoreThanOneApplications ? "all" : "none"
          }, {
            name: this.$t("sidebar.sections.documents"),
            route: "documents",
            can: "all"
          }, {
            name: this.$t("sidebar.sections.keyContacts"),
            route: "key-contacts",
            can: "all"
          }, {
            name: this.$t("sidebar.sections.support"),
            route: "support",
            can: "all"
          }, {
            name: this.$t("sidebar.sections.settings"),
            route: "settings",
            can: "all"
          }]
        }, {
          name: this.$t("global.website.legal"),
          tabs: [{
            name: this.$t("global.doorr.tos"),
            route: TOS_EXTERNAL_LINK(),
            can: "all",
            type: "link"
          }, {
            name: this.$t("global.doorr.privacyPolicy"),
            route: PRIVACY_EXTERNAL_LINK(),
            can: "all",
            type: "link"
          }]
        }]
      };
    },
    accountTypeTitle() {
      return this.$tc(`global.doorr.${this.accountDetails.accountType}`, 1);
    },
    agentsListLength() {
      return this.GET_ACCOUNT_AGENTS.agents ? this.GET_ACCOUNT_AGENTS.agents.length : "";
    },
    outstandingClassifications() {
      if (this.classifications.byApplication[this.selectedApplicationId]) {
        var _context2;
        const classifications = this.classifications.byApplication[this.selectedApplicationId];
        const outstandingRequestedDocuments = _filterInstanceProperty(_context2 = classifications.allIds).call(_context2, documentRequestId => {
          const classification = classifications.byId[documentRequestId];
          return classification.documents.length === 0;
        });
        return outstandingRequestedDocuments.length > 0;
      }
      return false;
    }
  }),
  methods: {
    getTabId(name) {
      return `${kebabCase(name)}-tab`;
    },
    getTabRoute(section, tab) {
      if (section) return `/${section}/${tab}`;
      return `/${tab}`;
    },
    async handleLogout() {
      var _this$$auth, _this$$auth$session, _this$$auth$session$g, _this$$auth$session$g2;
      const token = (_this$$auth = this.$auth) == null ? void 0 : (_this$$auth$session = _this$$auth.session) == null ? void 0 : _this$$auth$session.get == null ? void 0 : (_this$$auth$session$g = _this$$auth$session.get()) == null ? void 0 : (_this$$auth$session$g2 = _this$$auth$session$g.xData) == null ? void 0 : _this$$auth$session$g2.ref;
      try {
        if (token) {
          await logout(token);
        }
      } catch (e) {
        console.error("Logout failed", e);
      }
      this.$auth.session.end();
    },
    handleNewAppModal() {
      this.$refs.addNewApp.openModal();
    }
  }
});